import React, { Component } from 'react';
import "react-toggle/style.css";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import ActionIcon from '@material-ui/icons/AssignmentTurnedIn';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { isInteger, isFunction } from 'iotera-base/object';
import { TablePaginationActionsWrapped, CustomTableCell } from '..';
import { TASK_STAT_IN_PROGRESS, TASK_STAT_PENDING, TASK_STAT_SOLVED, TASK_STAT_RULE_SOLVED, TASK_STAT_CLOSED, TASK_STAT_RULE_NEW, TASK_STAT_NEW } from '../../../lib/components/Preference';
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { Switch } from '@material-ui/core';
import { ioteraConfirmAlert } from '../../../lib/components/react/react-confirm-alert';
import { getWidthColumnByPercent } from '../../../lib/components/function';
import { S } from '../../../routes/routes';

export default class TaskTable extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.goTo = this.goTo.bind(this);
    this.state = {
      tooltipOpen: false,
      page: 0,
      rowsPerPage: 5
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.handleChangeStatusToggle = this.handleChangeStatusToggle.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete = (taskId) => event => {
    let handleDelete = safeDeepGetWithType(this, ['props', 'handleDelete']);
    if (isFunction(handleDelete)) {
      ioteraConfirmAlert(
        'Konfirmasi Hapus Tugas',
        'Apakah anda yakin ingin menghapus tugas ini?',
        null,
        () => handleDelete(taskId),
        null,
        null
      )
    }
  }

  handleChangeStatusToggle = (id, value) => {
    const word = value ? 'mute' : 'menyalakan notifikasi'
    const handleChangeStatus = safeDeepGet(this, ['props', 'handleChangeStatus']);
    if (isFunction(handleChangeStatus)) {
      ioteraConfirmAlert(
        null,
        'Apakah anda yakin ingin ' + word + ' tugas ini?',
        null,
        () => handleChangeStatus(id, !value),
        null,
        null
      )
    }
  }

  onMouseEnter(key) {
    let dropdownOpen = Object.assign({}, this.state.dropdownOpen);
    // set dropdown visible 
    dropdownOpen[key] = true;
    this.setState({ dropdownOpen });
  }

  onMouseLeave(key) {
    let dropdownOpen = Object.assign({}, this.state.dropdownOpen);
    // set dropdown hidden 
    dropdownOpen[key] = false;
    this.setState({ dropdownOpen });
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage))
      rowsPerPage = parseInt(rowsPerPage)
    this.setState({ page: 0, rowsPerPage });
  };

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  handleAllCheck = event => {
    this.props.data.forEach((device, index, devices) => {
      devices[index].selected = event.target.checked
    })
    this.props.onCheckedDevice(event.target.checked)
  }

  handleCheck = (index, event) => {
    this.props.data[index].selected = event.target.checked
    this.props.onCheckedDevice(event.target.checked)
  }

  goTo(link) {
    this.props.history.push(link)
  }

  render() {
    let tableWidth = safeDeepGetWithType(this, ['props', 'tableSize', 'width'], 0);
    let data = this.props.data;
    const { rowsPerPage, page } = this.state;
    let taskRows = []
    Object.keys(this.props.data).forEach((key, index) => {
      let currData = data[key];
      let statusText = ""
      let dropdownIsOpen = safeDeepGetWithType(this, ['state', 'dropdownOpen', index], false);
      let id = safeDeepGetWithType(currData, ['id'], '');
      let name = safeDeepGetWithType(currData, ['name'], '');
      let description = safeDeepGetWithType(currData, ['description'], '-');
      let status = safeDeepGetWithType(currData, ['status'], '');
      let statusValue = safeDeepGetWithType(currData, ['status_value'], -1);
      let notification_active = safeDeepGetWithType(currData, ['notification_active'], false);
      let statusColor = '#000'
      if (statusValue === TASK_STAT_NEW) {
        statusColor = '#FF8800';
      } else if (statusValue === TASK_STAT_IN_PROGRESS) {
        statusColor = '#337AB7';
      } else if (statusValue === TASK_STAT_PENDING) {
        statusColor = '#939598';
      } else if (statusValue === TASK_STAT_SOLVED) {
        statusColor = '#007E34';
      } else if (statusValue === TASK_STAT_CLOSED) {
        statusColor = '#CC0001';
      } else if (statusValue === TASK_STAT_RULE_SOLVED) {
        statusColor = '#007E34';
      } else if (statusValue === TASK_STAT_RULE_NEW) {
        statusColor = '#FF8800';
      }
      statusText = <span style={{ color: statusColor }}>{status}</span>
      const colorOn = notification_active === true ? '#4D2C91' : '#B2B2B266';
      const colorOff = notification_active === false ? '#000' : '#B2B2B266';
      const visible = tableWidth > 576 ? 'visible' : 'collapse';
      taskRows.push(
        <TableRow key={index} className='table-row-child-iotera' >
          <TableCell component="th" scope="row" column='title' style={{ textAlign: 'left', fontSize: 14 }}>
            <span>
              <span>{name}</span><br />
            </span>
          </TableCell>
          <TableCell column='description' style={{ textAlign: 'left', minWidth: 164, maxWidth: 164 }}>
            <span style={{ fontStyle: 'italic' }}>
              {description}
            </span>
          </TableCell>
          <TableCell column='status' style={{ textAlign: 'left' }}>
            <span>
              {statusText}
            </span>
          </TableCell>
          <TableCell column='notif' style={{ textAlign: 'center' }}>
            <span>
              <i style={{ color: colorOff, visibility: visible }}>OFF</i>
              <Switch checked={notification_active} color="primary" onChange={() =>
                this.handleChangeStatusToggle(id, notification_active)} />
              <i style={{ color: colorOn, visibility: visible }}>ON</i>
            </span>
          </TableCell>
          <TableCell column='settings' style={{ textAlign: 'center' }} onMouseLeave={(e) => this.onMouseLeave(index)} >
            <UncontrolledDropdown isOpen={dropdownIsOpen}   >
              <DropdownToggle tag="div">
                <IconButton onMouseOver={(e) => this.onMouseEnter(index)} style={{ cursor: 'pointer', padding: 4 }}>
                  <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                </IconButton>
              </DropdownToggle>
              <DropdownMenu right style={{ padding: 0 }}>
                <DropdownItem style={{ margin: 0 }} onClick={(e) => this.goTo('.' + S + '_task_action_' + S + currData.id)}>
                  <ActionIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Aksi</span>
                </DropdownItem>
                <DropdownItem style={{ margin: 0 }} onClick={this.handleDelete(id)}>
                  <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Hapus</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </TableCell>
        </TableRow>
      )
    }
    )
    return (
      <Table className="table"      >
        <TableHead style={{ height: 0 }}>
          <TableRow>
            <CustomTableCell column='title' style={{
              textAlign: 'left', minWidth: getWidthColumnByPercent(25, tableWidth),
              maxWidth: getWidthColumnByPercent(25, tableWidth)
            }}><span>Nama</span></CustomTableCell>
            <CustomTableCell column='description' style={{
              textAlign: 'left', minWidth: getWidthColumnByPercent(25, tableWidth),
              maxWidth: getWidthColumnByPercent(25, tableWidth)
            }}><span>Deskripsi</span></CustomTableCell>
            <CustomTableCell column='status' style={{
              textAlign: 'left', minWidth: getWidthColumnByPercent(15, tableWidth),
              maxWidth: getWidthColumnByPercent(15, tableWidth)
            }}><span>Status</span></CustomTableCell>
            <CustomTableCell column='notification' style={{
              textAlign: 'center', minWidth: getWidthColumnByPercent(25, tableWidth),
              maxWidth: getWidthColumnByPercent(25, tableWidth)
            }}><span>Notifikasi</span></CustomTableCell>
            <CustomTableCell column='settings' style={{
              textAlign: 'center', minWidth: getWidthColumnByPercent(10, tableWidth),
              maxWidth: getWidthColumnByPercent(10, tableWidth)
            }}><span>Aksi</span></CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {taskRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
              labelRowsPerPage='Baris terlihat:'
              rowsPerPageOptions={[5, 10, 25]}
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                native: true,
              }}
              onPageChange={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActionsWrapped}
            />
          </TableRow>
        </TableFooter>
      </Table>
    );
  }
}